import React, { ReactElement } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import GroupsIcon from '@mui/icons-material/Groups';
import EventIcon from '@mui/icons-material/Event';
import CampaignIcon from '@mui/icons-material/Campaign';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';

export interface NavigationItem {
  label: string;
  path: string;
  icon?: ReactElement;
  requiresAuth?: boolean;
  requiresAdmin?: boolean;
  primary?: boolean;
}

export const navigationItems: NavigationItem[] = [
  {
    label: 'Home',
    path: '/',
    icon: <HomeIcon fontSize="small" />,
    primary: true,
  },
  {
    label: 'Groups',
    path: '/groups',
    icon: <GroupsIcon fontSize="small" />,
    primary: true,
  },
  {
    label: 'Events',
    path: '/meetings',
    icon: <EventIcon fontSize="small" />,
    primary: true,
  },
  {
    label: 'Broadcast',
    path: '/broadcast',
    icon: <CampaignIcon fontSize="small" />,
    requiresAdmin: true,
    primary: true,
  },
  {
    label: 'Profile',
    path: '/profile',
    icon: <PersonIcon fontSize="small" />,
    requiresAuth: true,
    primary: true,
  },
  {
    label: 'About',
    path: '/about',
    icon: <InfoIcon fontSize="small" />,
    primary: false,
  },
];

export const getVisibleNavigationItems = (
  isAuthenticated: boolean,
  isAdmin?: boolean,
): NavigationItem[] => {
  return navigationItems.filter(item => {
    if (item.requiresAuth && !isAuthenticated) {
      return false;
    }
    if (item.requiresAdmin && !isAdmin) {
      return false;
    }
    return true;
  });
};

export const getPrimaryNavigationItems = (
  isAuthenticated: boolean,
  isAdmin?: boolean,
): NavigationItem[] => {
  return getVisibleNavigationItems(isAuthenticated, isAdmin).filter(item => item.primary);
};

export const getSecondaryNavigationItems = (
  isAuthenticated: boolean,
  isAdmin?: boolean,
): NavigationItem[] => {
  return getVisibleNavigationItems(isAuthenticated, isAdmin).filter(
    item => !item.primary,
  );
};
